import { render, staticRenderFns } from "./gib.vue?vue&type=template&id=33133691&"
import script from "./gib.vue?vue&type=script&lang=js&"
export * from "./gib.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports